import { LoadingState } from "../../../root-store/api-result.state";
import { ServiceMetadataActions } from "../actions";
import { CHServiceMetadataState } from "../clarehome.state";

export const chServiceMetadatareducer = (
    state: CHServiceMetadataState = { result: null, uuid: "", callState: LoadingState.init },
    action: ServiceMetadataActions.Actions = null
): CHServiceMetadataState => {
    switch (action.type) {
        case ServiceMetadataActions.ActionTypes.ClearServiceMetadata: {
            return {
                result: null,
                uuid: null,
                callState: LoadingState.init,
            };
        }
        case ServiceMetadataActions.ActionTypes.GetServiceMetadata: {
            return {
                ...state,
                uuid: action.payload.uuid,
                callState: LoadingState.loading,
            };
        }

        case ServiceMetadataActions.ActionTypes.GetServiceMetadataSuccess: {
            return {
                ...state,
                result: action.result.result,
                uuid: action.result.uuid,
                callState: LoadingState.loaded,
            };
        }

        default: {
            return state;
        }
    }
};
